import ClipLoader from "react-spinners/ClipLoader";

const LoadingSpinner = () => {
  return (
    <div className="flex justify-center items-center h-screen z-50 w-screen">
      <ClipLoader color="#3498db" size={70} />
    </div>
  );
};

export default LoadingSpinner;
